<template>
  <header class="relative z-50 bg-white" role="banner" aria-label="Site header">
    <div class="flex justify-between items-center px-4 py-4 mx-auto max-w-basic lg:px-6">
      <a href="https://lifeboostcoffee.com/" aria-label="Go to homepage">
        <nuxt-img
          class="w-32 sm:w-40"
          preload
          format="webp"
          width="167"
          height="64"
          :src="logoSrc"
          :alt="logoAlt"
          loading="eager"
          fetchpriority="high"
        />
      </a>

      <button
        type="button"
        @click="scrollTo(scrollTarget)"
        class="inline-flex gap-3 items-center px-6 py-2.5 text-base font-medium text-white whitespace-nowrap rounded-full btn-hover-lift bg-lifeboost-red font-ww-medium sm:px-8 sm:text-lg"
        :aria-label="`${buttonText} - Navigate to ${scrollTarget} section`"
      >
        <span v-html="buttonText" />
        <svg  class="flex-shrink-0 w-3 h-3" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.000273357 7.93934L10.5559 7.93934L6.5581 12.6702L8.04351 13.9294L13.9297 6.96471L8.04351 -2.57293e-07L6.5581 1.25922L10.5559 5.99008L0.000273443 5.99008L0.000273357 7.93934Z" fill="white"/>
</svg>
      </button>
    </div>
  </header>
</template>

<script setup>
const props = defineProps({
  logoSrc: {
    type: String,
    default: '/assets/images/black-logo.svg'
  },
  logoAlt: {
    type: String,
    default: 'Lifeboost Coffee Logo'
  },
  buttonText: {
    type: String,
    default: 'Shop Now'
  },
  scrollTarget: {
    type: String,
    default: 'product'
  },
  buttonHref: {
    type: String,
    default: ''
  },
  mobilePosition: {
    type: String,
    default: 'bottom'
  }
})

defineBuilderComponent({
  friendlyName: 'Header - Logo Shop Now',
  inputs: [
    {
      name: 'logoSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png', 'webp'],
      defaultValue: '/assets/images/black-logo.svg'
    },
    {
      name: 'logoAlt',
      type: 'text',
      defaultValue: 'Lifeboost Coffee Logo'
    },
    {
      name: 'buttonText',
      type: 'text',
      defaultValue: 'Shop Now'
    },
    {
      name: 'scrollTarget',
      type: 'text',
      defaultValue: 'product'
    },
    {
      name: 'buttonHref',
      type: 'url',
      defaultValue: ''
    },
    {
      name: 'mobilePosition',
      type: 'enum',
      friendlyName: 'Scroll Position mobile',
      enum: [
        { label: 'Bottom', value: 'bottom' },
        { label: 'Top', value: 'top' }
      ],
      defaultValue: 'bottom'
    }
  ]
})
</script>
